import { VpIconButton } from '@vtmn-play/react'
import { VpArrowForwardIcon } from '@vtmn-play/icons/react'
import { useTranslation } from 'react-i18next'

interface LastFourWeeksTeamPerformanceHeaderProps {
  onOpenDetails: () => void
}

const LastFourWeeksTeamPerformanceHeader = ({ onOpenDetails }: LastFourWeeksTeamPerformanceHeaderProps) => {
  const { t } = useTranslation()

  return (
    <div className="mg-last-four-weeks-team-performance-header">
      <h2 className="vp-subtitle-l">{t('homepage.last-four-weeks-team-performance.title')}</h2>
      <VpIconButton
        data-testid="last-four-weeks-team-performance-action"
        variant="secondary"
        variant-style="regular"
        size="small"
        type="button"
        aria-label={t('homepage.last-four-weeks-team-performance.open-details')}
        onClick={onOpenDetails}
      >
        <VpArrowForwardIcon fontSize={16} />
      </VpIconButton>
    </div>
  )
}

export default LastFourWeeksTeamPerformanceHeader
